<div class="app-project-menu">
  <button class="topbar-icon-btn" (click)="openPanel()" title="Aplicações" #shortcutsOrigin>
    <span class="material-icons">grid_view</span>
  </button>

  <ng-template #shortcutsPanel>
    <div class="panel-container">
      <!-- Shortcuts (estilo f-card do Dashboard SSO/Direct) -->
      <div class="apps-grid">
        <ng-container *ngFor="let shortcut of shortcuts; trackBy: trackByFn">
          <a class="f-card" (click)="goToApplication(shortcut)" [title]="'Acessar ' + shortcut.label">
            <div class="card-icon">
              <span class="material-icons-outlined icon">{{shortcut.icon}}</span>
            </div>
            <div class="card-title"><span>{{shortcut.label}}</span></div>
            <div class="card-footer"><span>Acessar Sistema</span></div>
          </a>
        </ng-container>
      </div>

      <!-- No shortcuts -->
      <ng-container *ngIf="!shortcuts || !shortcuts.length">
        <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
          <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
            <span class="material-icons-outlined">bookmark</span>
          </div>
          <div class="mt-5 text-2xl font-semibold tracking-tight">Sem acessos disponíveis</div>
          <div class="wh-full max-w-60 mt-1 text-md text-center text-secondary">
            Quando você tiver algum acesso, eles aparecerão aqui.
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
